import { render, staticRenderFns } from "./CoozzyHeadsetIcon.vue?vue&type=template&id=ec0fc858&scoped=true"
import script from "./CoozzyHeadsetIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyHeadsetIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyHeadsetIcon.vue?vue&type=style&index=0&id=ec0fc858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0fc858",
  null
  
)

export default component.exports